import { Container, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import VNAutocomplete from '../VNAutocomplete/VNAutocomplete';
import VNSwitch from '../VNSwitch/VNSwitch';
import VNTextField from '../VNTextField/VNTextField';

interface IProps {
  isExisting: boolean;
  isSuperAdmin: boolean;
  isProfile: boolean;
}
const UserForm = ({ isExisting, isSuperAdmin, isProfile }: IProps) => {
  const formValue = useFormContext();

  return (
    <Container className="no-padding" maxWidth="lg">
      <Grid container className="section-box" spacing={2}>
        <Grid item xs={6}>
          <VNTextField name="userInfo.firstName" required label="First Name" />
        </Grid>
        <Grid item xs={6}>
          <VNTextField name="userInfo.lastName" required label="Last Name" />
        </Grid>
        <Grid item xs={12}>
          <VNTextField
            name="userInfo.email"
            required
            label="Email"
            disabled={isExisting}
            rules={{
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Please enter a valid email',
              },
            }}
          />
        </Grid>
        <Grid
          className="toggle-button-grid-row"
          item
          xs={6}
          sx={{
            display: { xs: isProfile ? 'none' : '' },
          }}
        >
          <VNSwitch name="enabled" label="Enabled" />
        </Grid>
        <Grid className="toggle-button-grid-row" item xs={6}>
          {isSuperAdmin && <VNSwitch name="userInfo.enableMFA" label="Enable MFA" />}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: { xs: isProfile ? 'none' : '' },
          }}
        >
          <VNAutocomplete
            name="roles"
            label="Roles"
            options={formValue.getValues('availableRoles')}
            labelProp="name"
            valueProp="id"
            multiple
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default UserForm;
